import { render, staticRenderFns } from "./WcLoadersCube.vue?vue&type=template&id=0925df22&lang=pug&"
import script from "./WcLoadersCube.vue?vue&type=script&lang=js&"
export * from "./WcLoadersCube.vue?vue&type=script&lang=js&"
import style0 from "./WcLoadersCube.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports